// @ts-ignore
export const API_URL = import.meta.env.VITE_APP_API_URL;
